import React from 'react';

export const onKeyEnter = (listener: React.KeyboardEventHandler) => (e: React.KeyboardEvent) => {
  if (e.key === 'Enter') {
    listener(e);
  }
};
